import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    load: false,
	token: '',
	doctorUser: {},//选择医生挂号
	hospital: '天峨县妇幼保健院成立于1976年4月，前身为天峨县妇幼保健站,是一所集医疗、保健于一体的医疗保健机构。承担着全县人口2/3的妇女儿童保健、健康教育、妇幼保健教学及妇产科、儿科等各种危重疑难病人的诊疗任务； 是全县妇幼保健、医疗技术业务指导中心，婚前医学检查、职工医疗保险、城乡居民医疗保险定点单位；1998年9月撤站建院，1999年率先获得"爱婴医院"称号。42年来，在各级党委、政府的关怀下，我院始终坚持"以保健为中心，以生殖健康为目的，临床与保健相结合，面向群体，面向基层"的办院方针，经过历届院领导及职工们艰苦创业，现全院占地总面积925.58㎡,总建筑面积3631.16㎡，床位55张。现有职工127人，专业技术人员110人，行政后勤17人，获得学历本科34人，专科78人，中专7人；其中执业医师18人，执业助理医师15人，临床护士54人，医技人员13人；高级职称9人,中级职称11人，初级职称90人。配备有彩色B超、DR成像系统、电子胃镜、心电图机、胎儿监护系统、母婴胎心监护仪、全自动生化分析仪、五分类血球仪、尿液分析系统仪、血红蛋白分析仪、凝血四项分析仪、血流变仪、电解质测定仪、免疫化学发光仪、婴儿培养箱、新生儿兰光治疗仪、麻醉机、电子阴道镜、红外线乳透仪、产后康复仪、新生儿复苏台、新生儿培养箱、心电监护仪、孕妇个体营养检测分析仪、胎儿脐血流检测系统、妊高征预测分析系统、低频脉冲综合康复治疗仪、光热波姆治疗仪、视力筛查仪、听力筛查仪、儿童发展评价系统、超声骨密度分析仪、微量元素检测仪、母乳分析仪等先进的医疗、保健、抢救设备。设有妇产科、儿科、妇女保健科、儿童保健科、婚检科、口腔科、医学检验科、医学影像科等10多个临床医技科室。根据功能定位，本院采取"送出去，引进来"和以老带新的人才培养战略，全面提高职工整体素质，专业技术力量日益增强。现能开展平、难产接生、儿科、新生儿科、妇科、产科危急重症治疗、儿童体格发育评价、高危孕产妇监测、微量元素测定、妇女病普查普治等项目及剖宫产术、全子宫切除、胃大部分切除术、肾切除、甲状腺次全切除术以及妇科、产科、普外、泌尿科、小儿外科等各种手术；坚持以市场为导向，走临床与保健相结合的道路，接受乡镇卫生院疑难危重病例转诊，使业务工作范围不断拓展，不断提高医务人员对疑难病例的综合处置能力，全县孕产妇死亡率、5岁以下儿童死亡、婴儿死亡率、新生儿死亡率、新生儿破伤风发生率逐年下降，住院分娩率逐年提高,取得了良好的社会效益和经济效益。我院奉行"保健质量第一、医疗质量第一、服务质量第一、病人利益第一"的办院宗旨，以精湛的技术、先进的设备、优质的服务和优美的环境，竭诚为全县广大妇女儿童健康服务。'
  },
  mutations:{
		Load(state, boolen){//loading显示隐藏
			state.load = boolen;
		},
		dUser(state, data){
			state.doctorUser = data;
		},
		token(state, data){
			state.token = data;
		}
  },
  getters:{
  	load: state =>{
  		return state.load
  	},
	
  	
  }
})



